import { Autocomplete, InputAdornment, TextField } from "@mui/material"
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import { alpha } from "@mui/material/styles"
import { PLAN_INPUT_FONT_SIZE } from "@/theme/panelStyles"
import { WW_BLUE, PANEL_TEXT_FAINT } from "@/theme/tokens"

// Vessel picker shared by the voyage planner's Plan step and the RNW
// analyser: boat icon, chevron popup, no clear button, panel styling.
export default function VesselAutocomplete({
  options,
  value,
  onChange,
  error = false,
  helperText = "",
  placeholder = "Search vessel...",
  disabled = false,
}) {
  return (
    <Autocomplete
      size="small"
      disabled={disabled}
      sx={{
        flex: 1,
        minWidth: 0,
        "& .MuiAutocomplete-input": { minWidth: "0 !important" },
      }}
      slotProps={{
        listbox: {
          sx: {
            "& .MuiAutocomplete-option": { fontSize: "13px" },
            "& .MuiAutocomplete-option[aria-selected='true']": {
              bgcolor: alpha(WW_BLUE, 0.12),
            },
            "& .MuiAutocomplete-option[aria-selected='true'].Mui-focused": {
              bgcolor: alpha(WW_BLUE, 0.18),
            },
          },
        },
      }}
      disableClearable
      popupIcon={<KeyboardArrowDownIcon sx={{ fontSize: 18 }} />}
      options={options}
      value={value}
      onChange={onChange}
      getOptionLabel={(option) => option?.name ?? ""}
      isOptionEqualToValue={(option, val) => option?.id === val?.id}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              bgcolor: "rgba(255,255,255,0.74)",
              pr: "6px !important",
            },
            "& .MuiInputBase-input": {
              fontSize: PLAN_INPUT_FONT_SIZE,
              textOverflow: "ellipsis",
            },
            "& .MuiFormHelperText-root": { fontSize: "12px", ml: 0.5 },
            "& .MuiAutocomplete-popupIndicator": { color: PANEL_TEXT_FAINT },
          }}
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps?.input,
              startAdornment: (
                <>
                  <InputAdornment position="start" sx={{ ml: 0.25, mr: 0 }}>
                    <DirectionsBoatIcon
                      sx={{ fontSize: 17, color: alpha(WW_BLUE, 0.7) }}
                    />
                  </InputAdornment>
                  {params.slotProps?.input?.startAdornment}
                </>
              ),
            },
          }}
        />
      )}
    />
  )
}
